import React from 'react';

class LoginForm extends React.Component{

    static defaultProps = {
        formName: "loginForm",
        method:"POST",
        rememberMeLabel: "Remember me on this computer",
        showRememberMe: true,
        submitBtnText: "Login",
        className: ""
    };
    
    render(){
        const { formName, showRememberMe, rememberMeLabel, submitBtnText, method, className } = this.props;
        return (
            <form className={'form ' + className} autoComplete="off" id={formName} name={formName} noValidate="" method={method}>
                <div className="form-group">
                    <label htmlFor="usernameInput">Username</label>
                    <input type="text" className="form-control" name="username" id="usernameInput" required="" />
                    <div className="invalid-feedback">Please enter your username or email</div>
                </div>
                <div className="form-group">
                    <label htmlFor="passwordInput">Password</label>
                    <input type="password" className="form-control" name="password" id="passwordInput" required="" autoComplete="new-password" />
                    <div className="invalid-feedback">Please enter a password</div>
                </div>
                {(showRememberMe)?
                <div className="form-check small">
                    <label className="form-check-label">
                        <input type="checkbox" className="form-check-input" name="rememberInput" id="rememberInput" /> <span>{rememberMeLabel}</span>
                    </label>
                </div>:null}
                <button type="submit" className="btn btn-primary btn-lg float-right" id="loginBtn">{submitBtnText}</button>
            </form>
        );
    }
}

export default LoginForm;
